export const gatesPath = '/branches/gates';
export const getGatebyId = (gateId: number) => `${gatesPath}/${gateId}`;
export const updateGateStatus = (id: number) => `${gatesPath}/${id}/activation`;
